
































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { maskCPFCNPJ } from '@/utils/common'

@Component

export default class ComponenteBackofficeHonorarioMedico extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  maskCPFCNPJUtil(value) {
    return maskCPFCNPJ(value)
  }
}
